import { EApprovalStatusValue } from '../../approval/interfaces/approval.interface';
import {
  ESalesOrderStatusValue,
  ESalesOrderPickingStatus,
  ISalesOrderSource,
} from '../interfaces/sales-order.interface';

const orderStatus = [
  { id: ESalesOrderStatusValue.AWAITING_SHIPMENT, name: 'Awaiting Shipment' },
  { id: ESalesOrderStatusValue.CANCELLED, name: 'Cancelled' },
  { id: ESalesOrderStatusValue.ON_HOLD, name: 'On Hold' },
  { id: ESalesOrderStatusValue.PENDING, name: 'Pending' },
  { id: ESalesOrderStatusValue.SHIPPED, name: 'Shipped' },
];

const pickAndPackStatus = [
  { id: ESalesOrderPickingStatus.PICKLIST_PACKED, name: 'Completed' },
  { id: ESalesOrderPickingStatus.PICKLIST_CREATED, name: 'Created' },
  { id: ESalesOrderPickingStatus.NOT_IN_PICKING, name: 'Not Created' },
  {
    id: ESalesOrderPickingStatus.NO_ENOUGH_STOCKS,
    name: 'Not Enough Stocks',
  },
  {
    id: ESalesOrderPickingStatus.PICKLIST_PICKING,
    name: 'Picking In-Progressd',
  },
];

const approvalStatus = [
  { id: EApprovalStatusValue.APPROVED, name: 'Approved' },
  { id: EApprovalStatusValue.REJECTED, name: 'Rejected' },
  { id: EApprovalStatusValue.PARTIAL, name: 'Partial' },
  { id: EApprovalStatusValue.PENDING, name: 'Pending' },
];

const invoicePaymentStatus = [
  { id: 0, name: 'Unpaid' },
  { id: 1, name: 'Fully Paid' },
  { id: 2, name: 'Partially Paid' },
  { id: 3, name: 'Pending Payment' },
];

const orderTypes = [
  { id: 'SALES_ORDER', name: 'Sales Order' },
  { id: 'INTERNAL_TRANSFER_ORDER', name: 'Internal Transfer Order' },
];

const invoiceStatusTypes = [
  { id: 'partially_invoiced', name: 'Partially Invoiced' },
  { id: 'shipment_invoiced', name: 'Shipment Invoiced' },
  { id: 'sales_order_invoiced', name: 'Sales Order Invoiced' },
  { id: 'invoiced', name: 'Invoiced' },
  { id: 'not_invoiced', name: 'Not Invoiced' },
];

const sources :ISalesOrderSource[] = [
  { id: 'amazon', name: 'Amazon' },
  { id: 'luminous', name: 'Luminous' },
  { id: 'shipstation', name: 'Shipstation' },
  { id: 'wooCommerce', name: 'WooCommerce' },
  { id: 'edi', name: 'Edi' },
  { id: 'transfer_order', name: 'Transfer Order' },
];

const woocommerceSourceConstant :ISalesOrderSource = {
  id: 'wooCommerce',
  name: 'WooCommerce',
};

const status = [
  { id: 0, name: 'Unallocated', value: false },
  { id: 1, name: 'Allocated', value: true },
];

const shippingOptions :any = {
  carrierCode: {
    label: 'Carrier',
    name: 'carrierCode',
    checked: false,
  },
  weight: {
    label: 'Weight',
    name: 'weight',
    checked: false,
  },
  serviceCode: {
    label: 'Service',
    name: 'serviceCode',
    checked: false,
  },
  packageCode: {
    label: 'Package',
    name: 'packageCode',
    checked: false,
  },
  dimensions: {
    label: 'Size',
    name: 'dimensions',
    checked: false,
  },
  confirmation: {
    label: 'Confirmation',
    name: 'confirmation',
    checked: false,
  },
  shipByDate: {
    label: 'Ship By Date',
    name: 'shipByDate',
    checked: false,
  },
};

export const lineItemStatusKeyLabel = {
  accepted: 'Accepted',
  backordered: 'Backordered',
  rejected: 'Rejected',
  quantity_changed: 'Quantity Changed',
};

export const SalesOrderConfig = {
  orderStatus,
  pickAndPackStatus,
  invoicePaymentStatus,
  approvalStatus,
  orderTypes,
  sources,
  status,
  woocommerceSourceConstant,
  shippingOptions,
  invoiceStatusTypes,
  lineItemStatusKeyLabel,
};

export enum EOrderTypeValue {
  SALES_ORDER = 'SALES_ORDER',
  INTERNAL_TRANSFER_ORDER = 'INTERNAL_TRANSFER_ORDER',
}

export enum ESalesOrderItemComposerType {
  ROLLBACK = 'rollback',
}
